export default {"src":"/_next/static/media/logo_100_white.ef3c52fa.svg","height":34,"width":158};